import styled from 'styled-components';
import Image from '@stencil/image';
import {
  CenteredSpaceWrap,
  CenteredDivWrap,
  PrimaryLink,
  ButtonBase,
  FlexItem,
} from '../../../../CommonStyleUtils/dwebCommon.styles';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';

export const WideImageModalWrap = styled.div(
  props => `
    width:97%;
      `,
);

export const WideImagePreviewConatiner = styled.div(
  props => `
    position:relative;
      `,
);

export const WideImagePreviewWrap = styled(CenteredSpaceWrap)(
  props => `
    width:100%;
    position: absolute;
    bottom: ${props.isVideo ? '-24px' : '2rem'};
    padding: 0 ${props.theme.spacing.custom(16)};
    `,
);

export const HappyAngleRightIconWrap = styled(CenteredDivWrap)(
  props => `
    width:4rem;
    height:4rem;
    cursor:pointer;
    border-radius:${props.theme.misc.borderRadius.round};
    background:${props.theme.colors.shadow.dark};
    `,
);

export const WideImagePreviewLabel = styled.div(
  props => `
    font-weight: 600;
    font-size: ${props.theme.font.custom(14)};
    color:${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.custom(16.5)};
    padding: ${props.theme.spacing.small} ${props.theme.spacing.custom(18)};
    background:${props.theme.colors.shadow.dark};
    `,
);

export const GuestRatingWrap = styled.div(
  props => `
    font-weight: 600;
    color:${props.theme.colors.goWhite.base};
    background:${getRatingsColor(props.totalRating)};
    border-radius:${props.theme.misc.borderRadius.base};
    padding: ${props.theme.spacing.xsmall} ${props.theme.spacing.small};
      `,
);

export const WideImageGuestReview = styled.div(
  props => `
    user-select: none;
    min-height:11.3rem;
    color:${props.theme.colors.goWhite.base};
    padding: ${props.theme.spacing.custom(16)};
    margin-bottom: ${props.theme.spacing.custom(8)};

      `,
);

export const GuestAvatarName = styled.p(
  props => `
    font-weight: 600;
    font-size: ${props.theme.font.custom(14)};
    color:${props.theme.colors.goWhite.base};
    text-transform: capitalize;
      `,
);

export const GuestAvatarImg = styled(Image)(
  props => `
    width:2.4rem;
    height:2.4rem;
    border-radius:${props.theme.misc.borderRadius.round};
    margin-right: ${props.theme.spacing.base};
    `,
);

export const GuestReviewDescription = styled.p(
  props => `
    margin-top: ${props.theme.spacing.custom(8)};
    height: 60px;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    >a{
        padding-left: ${props.theme.spacing.small};
    }
    `,
);

export const PropertyOverviewAmenities = styled.div(
  props => `
  margin-right: ${props.theme.spacing.custom(60)};
      `,
);

export const PropertyOverviewText = styled.p(
  props => `
    font-weight: 600;
    font-size: ${props.theme.font.custom(22)};
    color:${props.theme.colors.goWhite.base};
    margin-top: ${props.theme.spacing.base};
      `,
);

export const WideImageRoomDetailsWrap = styled.div(
  props => `
    display:flex;
    justify-content:space-between;
    color:${props.theme.colors.goWhite.base};
    margin-bottom: ${props.theme.spacing.custom(8)};
      `,
);

export const WideImageRoomAmenities = styled.div(
  props => `
  margin-bottom: ${props.theme.spacing.custom(4)};
  >div p{
      padding-bottom:${props.theme.spacing.custom(8)};
      margin-right: ${props.theme.spacing.custom(12)};
  }
      `,
);

export const WideImageViewRoomBtn = styled(ButtonBase)(
  props => `
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  margin-left: ${props.theme.spacing.custom(16)};
  padding:${props.theme.spacing.custom(16)} ${props.theme.spacing.custom(32)};
      `,
);

export const RoomInfo = styled.div(
  props => `
  display: flex;
  align-items: center;
  margin-right: 10px;
      `,
);

export const PropertyOverviewAmenitiesText = styled.p(
  props => `
    margin-left: ${props.theme.spacing.custom(8)};
      `,
);

export const PropertiesOverViewWrapper = styled(FlexItem)(
  props => `
  justify-content: space-between;
      `,
);

export const PlacesText = styled.p(
  props => `
    width:20rem;
      `,
);
